// extracted by mini-css-extract-plugin
module.exports = {"actionBtn":"overlay_actionBtn__22ml8","customScroll":"overlay_customScroll__23SZr"};